/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Dialog_Fallback_NoteInputs */



/**
* | output |
* | --- |
* | "Changelog not available in your language. Showing English." |
*
* @param {Release_Dialog_Fallback_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_fallback_note = /** @type {((inputs?: Release_Dialog_Fallback_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_Fallback_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Changelog in Ihrer Sprache nicht verfügbar. Zeige Englisch.")
	return /** @type {LocalizedString} */ ("Changelog not available in your language. Showing English.")
});